module.exports = __webpack_public_path__ + "0e270bc06ba34a189999da0952e0a996.png";


//////////////////
// WEBPACK FOOTER
// ./src/shared/images/tutorial/2.png
// module id = 1612
// module chunks = 0